import { Button, SearchInput, UserList, View } from '@/components'
import { ModalPage, ModalPageProps } from '../../../modals/ModalPage'
import { APIClient } from '@/services'
import { getFlatlistProps } from '@/utils'
import { ChatUser } from '@packages/chat'
import { useState } from 'react'
import { appStatusStore } from '@/stores'
import { Chat, theme } from '@/config'

export const NewChat = ({ request, onNextPage, visible, ...rest }: Partial<ModalPageProps>) => {
  const [search, setSearch] = useState('')

  const query = APIClient.Profiles.useProfiles({
    queryOptions: {
      enabled: visible,
    },
    filter: {
      name: search,
    },
  })

  const flatListProps = getFlatlistProps(query, {
    noMoreItemsText: '',
  })

  const handleOpenDM = async (user: ChatUser) => {
    try {
      appStatusStore.set('loading')
      const { data } = await Chat.API.createDM(user)
      request.resolve(data)
    } catch (error) {
      request.resolve(null)
      logger.log('Error opening DM:', error)
    } finally {
      appStatusStore.set('idle')
    }
  }

  return (
    <ModalPage
      {...rest}
      title='New Chat'
      canGoBack={false}
      closable={true}
    >
      <UserList
        {...flatListProps}
        ListHeaderComponent={() => (
          <View style={['column', 'fullWidth', 'px:3', 'gap:2', 'mb:0', {
            breakpoints: {
              mobile: ['px:2']
            }
          }]}>
            <SearchInput
              placeholder='Search'
              value={search}
              debounce={300}
              onSearchChange={setSearch}
              style={['noError']}
            />

            <Button
              debugName='NewChat:NewGroup'
              text='New group'
              style={['link:outline', 'textLeft']}
              icon='users-01'
              onPress={onNextPage}
            />
          </View>
        )}
        data={flatListProps.data as ChatUser[]}
        onPress={handleOpenDM}
        letterSeparatorShown
        style={{
          wrapper: {
            maxHeight: '60vh',
            overflow: 'auto',
            paddingBottom: theme.spacing.value(2),
          },
        }}
      />
    </ModalPage>
  )
}
